import script from "./DisplayCurriculumPresentation.vue?vue&type=script&setup=true&lang=js"
export * from "./DisplayCurriculumPresentation.vue?vue&type=script&setup=true&lang=js"

import "./DisplayCurriculumPresentation.vue?vue&type=style&index=0&id=75749205&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-75749205"]])

export default __exports__